<div class="supplier-other-options">
  <div class="upcoming-appointment" *ngIf="_user?.type?.value !== 'sublet'">

    <div class="ui-g-12 p-zero border-bottom-light pb-3 flex-column">
      <button [ngClass]="{ 'sidebar-disable': !_user.isActive }" *ngIf="_user?.type?.name !== 'Online'" id="upcoming-appt-btn-estimate" class="width-100p font-14 btn btn-primary btn-save text-left mb-2"
        >
        <div class="flex-between-center" (click)="openPO()">
          <span>
            <i class="fal fa-plus pr-6p"></i>
            <span class="pr-2">PO</span>
          </span>

          <span>
            <i *ngIf="isPurchaseOrderCreating" class="fal fa-spinner rotate"></i>
          </span>
        </div>
      </button>

      <button *ngIf="accPayable" id="bulk-appt-btn" class="width-100p font-14 btn btn-primary btn-save text-left"
      (click)="$event.stopPropagation();openBulkSupplierModal()">
        <i class="fal fa-plus pr-6p"></i>
        Bulk payment
      </button>
    </div>

    <div class="ui-g-12 p-zero plr-5 mt-2">
    </div>

  </div>

  <div class="mt-3">
    <p-accordion styleClass="upcoming-follow-up estimate-accordion with-right-chevron" [multiple]="true">
      <p-accordionTab *ngIf="accPayable" [selected]="true">
        <!--  header -->
        <!-- @TODO : FIX THIS IN CLASS -->
        <p-header style="display: flex;">
          <h2 class="accordion-trigger text-uppercase font-bold font-14">
              {{ _user?.type?.value !== 'sublet' ? 'OVERDUE POS('+overDuePosCount+')' : 'OVERDUE SUBLET PAYABLES('+overDuePosCount+')' }}
          </h2>
          <h2 class="accordion-trigger text-uppercase font-bold font-14 padding-overdue-view" (click)="$event.stopPropagation();viewList()" *ngIf="_user?.type?.value !== 'sublet'">
            View all
          </h2>
        </p-header>

        <!--  empty screen -->
        <div *ngIf="!overDuePos?.length && _user?.type?.value !== 'sublet'" class="mt-1 accordian-empty-screen">
          <div>
            <span class="fal fa-file-alt"></span>
          </div>
          There are no overdue POs.
        </div>

        <div *ngIf="!overDuePos?.length && _user?.type?.value === 'sublet'" class="mt-1 accordian-empty-screen">
          <div>
            <span class="fal fa-file-alt"></span>
          </div>
          There are no overdue ROs.
        </div>

        <!--  list -->
        <ng-conatiner *ngIf="_user?.type?.value !== 'sublet'">
          <div [hidden]="!overDuePos?.length" class="inner-accordion" *ngFor="let item of overDuePos; let i=index">
            <app-po-card [data]="item" [index]="i">
            </app-po-card>
          </div>
        </ng-conatiner>

        <!-- sublet supplier Ro list -->
        <ng-container *ngIf="overDuePos?.length && _user?.type?.value === 'sublet'">
          <div class="inner-accordion sublet-supplier" *ngFor="let item of overDuePos; let i=index">
            <app-ro-card [data]="item" [index]="i">
            </app-ro-card>
          </div>
        </ng-container>

      </p-accordionTab>

      <p-accordionTab [selected]="true">
        <!--  header -->
        <!-- @TODO : FIX THIS IN CLASS -->
        <p-header style="display: flex;">
          <h2 class="accordion-trigger text-uppercase font-bold font-14">
             {{_user?.type?.value !== 'sublet' ? 'Recent POS('+recentPosCount+')' : 'Recent Sublet Payables('+recentPosCount+')' }}
          </h2>
          <h2 class="accordion-trigger text-uppercase font-bold font-14 padding-view" (click)="$event.stopPropagation();viewList()" *ngIf="_user?.type?.value !== 'sublet'">
            View all
          </h2>
        </p-header>

        <!--  empty screen -->
        <div *ngIf="!recentPos?.length && _user?.type?.value !== 'sublet'" class="mt-1 accordian-empty-screen">
          <div>
            <span class="fal fa-file-alt"></span>
          </div>
          No purchase orders have been created for this supplier so far.

        </div>

        <div *ngIf="!recentPos?.length && _user?.type?.value === 'sublet'" class="mt-1 accordian-empty-screen">
          <div>
            <span class="fal fa-file-alt"></span>
          </div>
          No Repair orders have been created for this supplier so far.

        </div>

        <!-- card list -->
        <ng-container *ngIf="_user?.type?.value !== 'sublet'">
          <div [hidden]="!recentPos?.length" class="inner-accordion" *ngFor="let item of recentPos; let i=index">
            <app-po-card [data]="item" [index]="i">
            </app-po-card>
          </div>
        </ng-container>

        <!-- Sublet recent Ro list -->
        <ng-container *ngIf="recentPos?.length && _user?.type?.value === 'sublet'">
          <div class="inner-accordion sublet-supplier" *ngFor="let item of recentPos; let i=index">
            <app-ro-card [data]="item" [index]="i">
            </app-ro-card>
          </div>
        </ng-container>

      </p-accordionTab>
    </p-accordion>
  </div>

</div>
